/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Password_Errors_Duplicate_EmailInputs */

const nl_auth_password_errors_duplicate_email = /** @type {(inputs: Auth_Password_Errors_Duplicate_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dit e-mailadres is al in gebruik`)
};

/**

* @param {Auth_Password_Errors_Duplicate_EmailInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const auth_password_errors_duplicate_email = /** @type {((inputs?: Auth_Password_Errors_Duplicate_EmailInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Password_Errors_Duplicate_EmailInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_auth_password_errors_duplicate_email(inputs)
});
export { auth_password_errors_duplicate_email as "auth.password_errors.duplicate_email" }